import React, { useState, useEffect } from "react";
import tdata from "../timezone.json";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { imageToBase64 } from "../utils";
import db, { storage } from "../firebase";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch, connect } from "react-redux";
import { set_branch_info, set_add_step } from "../redux/Branch/branchAction";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { notify } from "react-notify-toast";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
}));

const BasicInfo = (props) => {
  let { id, edit } = props;
  const classes = useStyles();
  const state = useSelector((state) => state.branch);
  const dispatch = useDispatch();
  const history = useHistory();
  const [brandName, setbranch_] = useState("");
  const [loading, setLoading] = useState(false);
  const [branchName, setBranchName] = useState("");
  const [branchEmail, setBranchEmail] = useState("");
  const [branchContact, setBranchContact] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [texRate, setTextRate] = useState("");
  const [taxStatus, setTaxStatus] = useState("Inclusive");
  const [taxbtn, setTaxbtn] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isEdit, setEdit] = useState(false);
  const [brands, setBrands] = useState([{}]);

  const [user, setuser] = useState(JSON.parse(localStorage.getItem("Ubytes")));
  const [brandBanner, setBrandBanner] = useState(false);
  const [bannerPreview, setBrandBannerPreview] = useState(false);
  const [error, seterror] = useState("");
  const taxtBtnHandler = (type) => {
    if (type === "inclusive") {
      setTaxStatus("Inclusive");
      setTaxbtn(false);
    } else if (type === "exclusive") {
      setTaxStatus("Exclusive");
      setTaxbtn(true);
    }
  };
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //
    re.test(String(email).toLowerCase())
      ? setBranchEmail(email)
      : seterror("email");
    return re.test(String(email).toLowerCase());
  };
  const onBannerChange = async (e) => {
    if (e.target.files?.length > 0) {
      const file = e.target.files[0];
      const size = file.size / 1024 / 1024;
      if (size <= 1) {
        const banner = await imageToBase64(file);
        setBrandBannerPreview(banner);
        setBrandBanner(file);
      }
    }
  };

  useEffect(() => {
    if (id) {
      getdata(id);
    } else {
      setLoading(false);
    }
  }, []);

  const getdata = async (id) => {
    setLoading(true);
    const doc = await db.collection("Branches").doc(id).get();
    let data = null;
    if (doc.exists) {
      data = doc.data();
      if (data) {
        setBranchName(data?.branchName);
        setBranchContact(data?.branchContact || "");
        setTimeZone(data?.timeZone);
        setTextRate(data?.taxRate);
        setTaxStatus(data?.taxStatus);
        setBranchEmail(data?.branchEmail);
        setSelectedBrands(data?.ofBrand);

        setBrandBanner(data?.brandBanner);
        setBrandBannerPreview(data?.brandBanner);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (props.id) {
      if (props.id) {
        getdata(props.id);
      }
    }
    if (brandBanner) {
      const objectUrl = URL.createObjectURL(brandBanner);

      return () => URL.revokeObjectURL(objectUrl);
    }
    if (user.role === "Superadmin" && !props.id) {
      loadBrands();
    }
  }, []);

  const loadBrands = async (e) => {
    if (!edit) {
      var data = [];
      var d = await db.collection("Merchant").orderBy("brandName").get();
      d.forEach((element) => {
        var k = element.data();
        k["label"] = element.data().brandName;
        k["value"] = element.data().brandName;
        k["id"] = element.id;
        data.push(k);
      });

      setBrands(data);
    }
  };

  const submit = async () => {
    setLoading(true);
    for (let index = 0; index < branchEmail.length; index++) {
      delete branchEmail[index]["__isNew__"];
    }
    if (
      texRate === "" ||
      branchName === "" ||
      branchContact === "" ||
      timeZone === "" ||
      !brandBanner
    ) {
      notify.show("Please check your inputs properly", "warning");
      setLoading(false);
      return;
    }
    let email = branchEmail[0].value;

    if (!validateEmail(email)) {
      notify.show("Please check your email format", "warning");
      setLoading(false);
      return;
    }

    let uploadLink = brandBanner;

    if (brandBanner !== bannerPreview) {
      var storageRef = storage.ref("brandBanner/" + id);
      const uploadBanner = await storageRef.put(brandBanner);
      uploadLink = await uploadBanner.ref.getDownloadURL();
    }
    let userPayload = JSON.parse(localStorage.getItem("Ubytes"));
    var data =
      userPayload.role === "Superadmin"
        ? {
            of: edit ? selectedBrands.value : selectedBrands.uid,
            ofBrand: edit
              ? selectedBrands
              : {
                  value: selectedBrands.uid,
                  label: selectedBrands.brandName,
                },
            branchName: branchName,
            branchEmail: branchEmail,
            branchContact: branchContact,
            taxStatus: taxStatus,
            taxRate: texRate,
            brandBanner: uploadLink,
            timeZone: timeZone,
            ofMerchant: edit ? selectedBrands.value : selectedBrands.uid,
          }
        : {
            ofMerchant: userPayload.of,
            branchName: branchName,
            branchEmail: branchEmail,
            branchContact: branchContact,
            taxStatus: taxStatus,
            taxRate: texRate,
            brandBanner: uploadLink,
            timeZone: timeZone,
            of: userPayload.of,
            ofBrand: userPayload.brandName,
          };

    await dispatch(set_branch_info({ basicInfo: data })).then(async () => {
      if (edit) {
        await db.collection("Branches").doc(id).update(data);
      } else {
        await db
          .collection("Branches")
          .add(data)
          .then(async (k) => {
            var banner = storage.ref("branchBanner/" + k.id);
            id = k.id;
            await banner.put(brandBanner);
            data.brandBanner = await banner.getDownloadURL();
            data.branchId = k.id;
            data.of = k.id;
            k.update(data);
          });

        db.collection("Branches").doc(id).set(data);
      }
      setLoading(false);
      history.push({
        pathname: edit ? `/branch/edit/${id}/auth` : `/branch/add/auth`,
        state: { id },
      });
    });
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
        <div className={classes.text}>Loading</div>
      </Backdrop>
      <h2>Basic Information</h2>

      <div className="add_form_control-select">
        <p>
          <strong>Brand Name: </strong>
          {user.role === "Merchant" ? (
            user.brandName
          ) : id ? (
            selectedBrands.label
          ) : (
            <Select
              options={brands}
              onChange={(e) => setSelectedBrands(e)}
            ></Select>
          )}
        </p>
      </div>
      <div className="input_group">
        <label htmlFor="">Branch Name</label>
        <input
          className="form_input"
          type="text"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
        />
      </div>
      <div className="add_form_control-select">
        <label htmlFor="pDesc">Email</label>
        <CreatableSelect
          isClearable
          onChange={(e) => setBranchEmail(e)}
          isMulti
          value={branchEmail}
          options={branchEmail}
          className="basic-multi-select"
          classNamePrefix="select"
        ></CreatableSelect>
      </div>

      <div className="input_group">
        <label htmlFor="">Branch Contact</label>
        <input
          className="form_input"
          type="number"
          value={branchContact}
          onChange={(e) => setBranchContact(e.target.value)}
        />
      </div>
      <div className="input_group">
        <label htmlFor="">TimeZone</label>
        <Select
          onChange={(e) => setTimeZone(e)}
          options={tdata}
          classNamePrefix="select"
          isSearchable
          value={timeZone}
        ></Select>
      </div>
      <div className="add_form_control">
        <div className="cover__image">
          <p>Brand Banner</p>
          <div className="cover_image_control">
            <label
              className="coverImage"
              htmlFor="productImage"
              style={
                bannerPreview
                  ? {
                      backgroundImage: `url(${bannerPreview})`,
                      color: "rgba(0,0,0,0)",
                    }
                  : {}
              }
            >
              {!bannerPreview && (
                <p>
                  Drag and drop Branch Photo or <br /> browse to upload
                </p>
              )}

              {/* {!bannerPreview && (
								<p>
									Drag and drop Branch Photo or <br /> browse to upload
								</p>
							)} */}
            </label>

            <span>
              Max of 1 MB, at least 450x250 pixels and only JPEG and PNG are
              Allowed
            </span>
            <input
              className="productImageInput"
              name="productImage"
              id="productImage"
              type="file"
              accept=".png, .jpg, .jpeg"
              onChange={(e) => onBannerChange(e)}
            />
          </div>
        </div>
      </div>
      <div className="form_input_group">
        <div className="input_group tax_group">
          <label htmlFor="">Tax Rate %</label>
          <input
            className="form_input"
            type="number"
            value={texRate}
            onChange={(e) => setTextRate(e.target.value)}
          />
        </div>
        <div className="input_group btn_switch_parent">
          <label htmlFor="">Tax Status</label>
          <div className="form_input btn_switch_group">
            <input
              type="button"
              className={
                taxStatus === "Inclusive"
                  ? "btn_normal bg_light_blue"
                  : "btn_normal"
              }
              value="Inclusive"
              onClick={() => taxtBtnHandler("inclusive")}
            />
            <input
              type="button"
              className={
                taxStatus === "Exclusive"
                  ? "btn_normal bg_light_blue"
                  : "btn_normal"
              }
              value="Exclusive"
              onClick={() => taxtBtnHandler("exclusive")}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <button type="submit" className="btn_light_blue" onClick={submit}>
          Save Changes
        </button>
        <input type="button" className="btn_light_blue ml-2" value="Reset" />
      </div>
    </div>
  );
};

const mapState = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapState)(BasicInfo);
